import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/dashboard-shell";
import { CustomerDetail } from "@/components/customers/customer-detail";
import {
  RouteLoading,
  CustomerDetailLoadingSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/customers/$id")({
  component: CustomerDetailPage,
  head: () => ({ meta: [{ title: "Business" }] }),
  pendingComponent: CustomerDetailPending,
});

function CustomerDetailPage() {
  // Was `await params` in the Next page. The router already gives the segment
  // decoded, so the explicit decodeURIComponent the Next version needed is
  // gone.
  const { id } = Route.useParams();
  return (
    <DashboardShell>
      <CustomerDetail id={id} />
    </DashboardShell>
  );
}

function CustomerDetailPending() {
  return (
    <RouteLoading>
      <CustomerDetailLoadingSkeleton />
    </RouteLoading>
  );
}
